// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./~/@girder/girder_xtk_demo/xtkItemView.styl
// module id = 6
// module chunks = 0